export default "__VITE_ASSET__CvXL0xS2__";